<div class="flex gap-1 items-center">
  <button
    class="btn btn-ghost btn-sm min-w-9 h-9 rounded-lg px-0 disabled:bg-transparent disabled:opacity-30"
    [disabled]="isFirstDisabled()"
    (click)="handlePageChange(1)">
    <lepi-icon name="ri:skip-left-line" class="!size-5 text-gray-500" />
  </button>
  <button
    class="btn btn-ghost btn-sm min-w-9 h-9 rounded-lg px-0 disabled:bg-transparent disabled:opacity-30"
    [disabled]="isFirstDisabled()"
    (click)="handlePageChange(pageNo() - 1)">
    <lepi-icon name="mdi:chevron-left" class="!size-5 text-gray-500" />
  </button>

  @for (_page of pages(); track _page) {
    <button
      class="btn btn-sm min-w-9 h-9 rounded-lg font-medium px-0"
      [class.btn-primary]="pageNo() === _page"
      [class.btn-ghost]="pageNo() !== _page"
      (click)="handlePageChange(_page)">
      {{ _page }}
    </button>
  }

  <button
    class="btn btn-ghost btn-sm min-w-9 h-9 rounded-lg px-0 disabled:bg-transparent disabled:opacity-30"
    [disabled]="isLastDisabled()"
    (click)="handlePageChange(pageNo() + 1)">
    <lepi-icon name="mdi:chevron-right" class="!size-5 text-gray-500" />
  </button>
  <button
    class="btn btn-ghost btn-sm min-w-9 h-9 rounded-lg px-0 disabled:bg-transparent disabled:opacity-30"
    [disabled]="isLastDisabled()"
    (click)="handlePageChange(pageInfo().totalPages || 1)">
    <lepi-icon name="ri:skip-right-line" class="!size-5 text-gray-500" />
  </button>
</div>
